import React from 'react';
import Select from 'react-select';

import Const from '../../../util/Constants';
import Util from "../../../util/Util";

class AutomationModuleSelect extends React.Component {

  render() {
    const models = this.props.models;
    const onChange = this.props.onChange;
    const model = this.props.model;

    const restricted = this.props.restricted && this.props.restricted.length
      ? this.props.restricted : null;
    const options = [ ];
    if(Util.isAllow(models.lead.permission, Const.PermView) 
      && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'lead')))) {
      options.push({ label: models.lead.model_name, value: 'lead' });
    }
    if(Util.isAllow(models.sales_order.permission, Const.PermView) 
      && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'sales_order')))) {
      options.push({ label: models.sales_order.model_name, value: 'sales_order' });
    }
    if(Util.isAllow(models.call.permission, Const.PermView) 
      && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'call')))) {
      options.push({ label: models.call.model_name, value: 'call' });
    }
    if(Util.isAllow(models.meeting.permission, Const.PermView) 
      && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'meeting')))) {
      options.push({ label: models.meeting.model_name, value: 'meeting' });
    }
    if(Util.isAllow(models.note.permission, Const.PermView) 
      && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'note')))) {
      options.push({ label: models.note.model_name, value: 'note' });
    }
    if(Util.isAllow(models.meeting.permission, Const.PermView) 
      && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'property')))) {
      options.push({ label: models.property.model_name, value: 'property' });
    }
    if(Util.isAllow(models.note.permission, Const.PermView) 
      && ( !restricted || (restricted && restricted.find(innerModel => innerModel === 'project')))) {
      options.push({ label: models.project.model_name, value: 'project' });
    }
    
    return (
      <div className={`form-group col-md-${this.props.size ? this.props.size : 12}`}>
        <Select
          value={options.find(field => field.value === model)}
          className="mr-sm-2"
          options={options}
          onChange={select => onChange('model', select ? select.value : null)}
          isSearchable={true}
          isClearable={true} />
      </div>
    );
  }
}
export default AutomationModuleSelect;
